module.exports = __webpack_public_path__ + "static/media/performance-icon.6d32e899.svg";